import { Injectable } from "@angular/core";
import { ShellDomainProvider } from './shell-domain.provider';

declare let document: any;
declare const mixpanel: any;
declare const ga: any;

interface IScripts {
    name: string;
    src: string;
}

@Injectable()
export class ScriptLoaderService {

    private scripts: any = {};
    private gtagConfigured = false;

    constructor() {
        const ScriptStore: IScripts[] =
            [
                { name: 'MixPanel', src: ShellDomainProvider['api']['CdnBaseUrl']+ 'common/angulartics/mixpanel.js' },
                { name: 'google-analytics', src: ShellDomainProvider['api']['CdnBaseUrl']+ 'common/angulartics/google-analytics.js' },
                { name: 'Jquery', src: ShellDomainProvider['api']['CdnBaseUrl']+ 'common/signalr/jquery-2.1.1.min.js' },
                { name: 'JqSignalr', src: ShellDomainProvider['api']['CdnBaseUrl']+ 'common/signalr/jquery.signalR-2.2.2.min.js' }
            ];

        ScriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });
    }

    load(scripts: string[], trackingId?) {
        var promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script, trackingId)));
        return Promise.all(promises);
    }

    loadScript(name: string, trackingId?: string) {
        let script = {};
        return new Promise((resolve, reject) => {
            //resolve if already loaded
            if (this.scripts[name] && this.scripts[name].loaded) {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
            else {
                //load script
                script = document.createElement('script');
                script['type'] = 'text/javascript';
                script['src'] = (this.scripts[name] && this.scripts[name].src) || name;
                script['async'] = true;
                script['charset'] = 'utf-8';
                script['id'] = trackingId;

                if (script['readyState']) {  //IE
                    script['onreadystatechange'] = () => {
                        if (script['readyState'] === "loaded" || script['readyState'] === "complete") {
                            script['onreadystatechange'] = null;
                            this.scripts[name].loaded = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                } else {  //Others
                    script['onload'] = () => {
                        switch (name) {
                            case 'MixPanel':
                                mixpanel.init(trackingId, { api_host: "https://api.mixpanel.com" });
                                break;
                            case 'google-analytics':
                                ga('create', trackingId, 'auto');
                                break;
                            default:
                                break;
                        }

                        if(this.scripts[name]){
                            this.scripts[name].loaded = true;
                        }

                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script['onerror'] = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }

    // Google analytics 4
    loadGTag(scripts: string[], measurementID: string, userId?: string) {
      var promises: any[] = [];
      scripts.forEach((script) => promises.push(this.loadScriptForGTag(script, measurementID, userId)));
      return Promise.all(promises);
    }

    loadScriptForGTag(name: string, measurementID: string, userId?: string) {
      return new Promise((resolve, reject) => {

          // google analyics 4 script
          let scriptTag = document.getElementById('google-tag-manager-src');
          if (scriptTag) {
            resolve({ script: name, loaded: true, status: 'GTag Already Loaded' });
          }
          else {
            let gaScript = document.createElement('script');
            gaScript.setAttribute('async', 'true');
            gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${ measurementID }`);
            gaScript.setAttribute('id', 'google-tag-manager-src');
            document.getElementsByTagName('head')[0].appendChild(gaScript);
          }

          // Configured in code rather than an inline <script>, which Trusted Types blocks.
          if (!this.gtagConfigured) {
            const w = window as any;
            w.dataLayer = w.dataLayer || [];
            w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
            w.gtag('js', new Date());
            if (userId) {
              w.gtag('config', measurementID, { 'user_id': userId });
              w.gtag('set', 'user_properties', { 'crm_id': userId });
            }
            else {
              w.gtag('config', measurementID);
            }
            this.gtagConfigured = true;
          }
          this.scripts[name].loaded = true;
      });
    }
}
